export function getBrandLogoUrl(url: string) {
	return process.env.REACT_APP_BRANDS_UPLOADS_URL + url;
}
